import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

import {
  ISelectedDocument,
  SELECTED_DOC_FORM_FIELDS,
} from '../selected-docs.component';

@Component({
  selector: 'ib-selected-doc',
  templateUrl: './selected-doc.component.html',
})
export class SelectedDocComponent implements OnInit {
  @Input() docForm: FormGroup;
  @Input() document: ISelectedDocument;

  public showPreview: boolean;
  public readonly FORM_FIELDS = SELECTED_DOC_FORM_FIELDS;
  public pdfSrc: any;

  get doc(): ISelectedDocument {
    return this.docForm?.get(SELECTED_DOC_FORM_FIELDS.DOCUMENT)?.value;
  }
  get docNameFormCtrl(): AbstractControl {
    return this.docForm?.get(SELECTED_DOC_FORM_FIELDS.DOC_NAME);
  }

  @Output() removeMe = new EventEmitter<string>();

  ngOnInit(): void {
    if (this.document.isFilePdf && typeof FileReader !== 'undefined') {
      const reader = new FileReader();
      reader.onload = e => {
        this.pdfSrc = e.target.result;
      };
      reader.onerror = e => {
        console.error(e);
      };
      reader.readAsArrayBuffer(this.document.file);
    }
  }
}
